// @flow

export const hasFAQFeedbackUrl = () => Boolean(process.env.LISTO_FAQ_FEEDBACK_URL);
export const getFAQFeedbackUrl = () => process.env.LISTO_FAQ_FEEDBACK_URL;

export default null;
